export const connections: Connections = {
  local: {
    apiUrl: "http://localhost:3000",
    socketIO: "http://localhost:3000",
  },
  hmr: {
    apiUrl: "http://localhost:3000",
    socketIO: "ws://localhost:3000",
  },
  development: {
    apiUrl: "https://innovation.movitext.com:3000",
    socketIO: "wss://innovation.movitext.com:3000",
  },
  testing: {
    apiUrl: "https://innovation.movitext.com:3000",
    socketIO: "wss://innovation.movitext.com:3000",
  },
  bcr: {
    apiUrl: "http://10.0.243.246:3000",
    socketIO: "ws://10.0.243.246:3000",
  },
  staging: {
    // apiUrl: "http://172.31.78.216",
    apiUrl: "https://messagebk-stg.movitext.com",
    // socketIO: "ws://172.31.78.216",
    socketIO: "wss://messagebk-stg.movitext.com",
  },
  production: {
    apiUrl: "https://messagebk.movitext.com",
    socketIO: "wss://messagebk.movitext.com",
  },
};

export interface Connections {
  local: Connection;
  development: Connection;
  testing: Connection;
  production: Connection;
  staging: Connection;
  bcr: Connection;
  hmr: Connection;
}

export interface Connection {
  apiUrl: string;
  socketIO: string;
}
